// ClientSelectionManager Hook
// Mirrors a server-confirmed TenantAPP client context for in-tab UX only.

export const ClientSelectionManager = {
  mounted() {
    this.tenantId = this.el.getAttribute('data-tenant-id');
    this.userId = this.el.getAttribute('data-user-id') || 'anonymous';

    if (!this.tenantId) {
      console.error('[ClientSelectionManager] Tenant ID missing');
      return;
    }

    const currentUrl = new URL(window.location.href);
    const urlClientId = this.parseClientId(currentUrl.searchParams.get('client_id'));

    if (urlClientId !== null) {
      this.storeSelection(urlClientId);
    }

    this.handleEvent('persist_client_selection', ({ client_id, tenant_id }) => {
      if (tenant_id && String(tenant_id) !== String(this.tenantId)) {
        return;
      }

      this.storeSelection(client_id);
    });
  },

  storageKey() {
    return ['mealflow', 'client_selection', this.tenantId, this.userId].join(':');
  },

  getStoredSelection() {
    return this.parseClientId(this.safeGetItem(this.storageKey()));
  },

  storeSelection(clientId) {
    const parsed = this.parseClientId(clientId);

    if (parsed === null) {
      return false;
    }

    return this.safeSetItem(this.storageKey(), String(parsed));
  },

  parseClientId(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const parsed = Number.parseInt(String(value), 10);

    if (Number.isInteger(parsed) && parsed >= 0 && String(parsed) === String(value).trim()) {
      return parsed;
    }

    return null;
  },

  safeGetItem(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  },

  safeSetItem(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
      return true;
    } catch (_error) {
      return false;
    }
  }
};
